<template>
  <div class="container">
    <app-header title="编辑产品信息" />
    <div class="main">

      <div class="form">
        <div class="form-group">
          <div class="name">
            <img src="@/assets/star.png"
                 alt="必填"
                 width="10"
                 height="10"
                 class="star">
            <span>产品名称</span>
          </div>
          <input type="text"
                 class="input"
                 v-model="p_name">
        </div>
        <div class="form-group">
          <div class="name">
            <img src="@/assets/star.png"
                 alt="必填"
                 width="10"
                 height="10"
                 class="star">
            <span>产品型号</span>
          </div>
          <input type="text"
                 class="input"
                 v-model="p_type">
        </div>
        <div class="form-group">
          <div class="name">
            <img src="@/assets/star.png"
                 alt="必填"
                 width="10"
                 height="10"
                 class="star">
            <span>封 装</span>
          </div>
          <input type="text"
                 class="input"
                 v-model="sealed ">
        </div>
        <div class="form-group">
          <div class="name">
            <img src="@/assets/star.png"
                 alt="必填"
                 width="10"
                 height="10"
                 class="star">
            <span>产品数量</span>
          </div>
          <input type="text"
                 class="input"
                 v-model="p_num">
        </div>
        <div class="form-group">
          <div class="name">
            <img src="@/assets/star.png"
                 alt="必填"
                 width="10"
                 height="10"
                 class="star">
            <span>价格要求</span>
          </div>
          <input type="text"
                 class="input"
                 v-model="p_require">
        </div>
        <div class="form-group">
          <div class="name">
            <img src="@/assets/star.png"
                 alt="必填"
                 width="10"
                 height="10"
                 class="star">
            <span>品牌要求</span>
          </div>
          <input type="text"
                 class="input"
                 v-model="brand_require">
        </div>
        <div class="form-group">
          <div class="name">
            <img src="@/assets/star.png"
                 alt="必填"
                 width="10"
                 height="10"
                 class="star">
            <span>产品要求</span>
          </div>
          <van-field rows="2"
                     autosize
                     class="textarea"
                     type="textarea"
                     maxlength="200"
                     placeholder="请输入产品要求"
                     v-model="p_ask" />
        </div>
        <div class="form-group">
          <div class="name">
            <img src="@/assets/star.png"
                 alt="必填"
                 width="10"
                 height="10"
                 class="star">
            <span>图片上传</span>
          </div>
          <van-uploader class="uploader"
                        :after-read="afterRead"
                        v-model="fileList" />
        </div>
        <div class="form-group">
          <div class="name">
            <span>产品规格书</span>
          </div>
          <div class="pdf">
            <img src="@/assets/pdf.png"
                 alt="必填"
                 width="33px">
            <span>产品规格书</span>
            <img src="@/assets/right.png"
                 alt="必填"
                 class="right">
          </div>
        </div>
      </div>
      <div class="submit"
           @click="onNavigate">保存</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data () {
    return {
      radio: 1,
      //上传文件预览数组
      fileList: [{ url: 'https://img.yzcdn.cn/vant/leaf.jpg' }],
      p_name: '广告宣传', // 产品名称
      p_type: 'xxx-021233321',// 产品型号
      sealed: '0.8*2m', // 封装
      p_num: '100', //产品数量
      p_require: '199.02', //价格要求
      brand_require: '商务电子', //品牌要求
      p_ask: '电子产品芯片用途广泛,性能好' //产品要求
    }
  },
  methods: {
    onNavigate () {
      this.$router.push({
        path: '/ticket/list'
      })
    },
    // 文件上传成功触发
    afterRead (file) {
      console.log(file);
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  .main {
    padding: 6px 12px 12px 18px;
    .form {
      .form-group {
        .star {
          margin: 0 10px;
        }
        .name {
          height: 22px;
          font-size: 16px;
          font-weight: 400;
          line-height: 21px;
          color: rgba(153, 153, 153, 1);
          margin-top: 8px;
        }
        .input {
          width: 90%;
          height: 20px;
          border: 1px solid rgba(243, 243, 243, 1);
          border-radius: 4px;
          padding: 10px;
          font-size: 16px;
          font-weight: 400;
          line-height: 21px;
          margin-top: 8px;
        }
      }
    }
    .submit {
      height: 40px;
      background: linear-gradient(
        0deg,
        rgba(244, 4, 66, 1) 0%,
        rgba(226, 23, 75, 0.73) 100%
      );
      border-radius: 4px;
      line-height: 40px;
      margin-top: 18px;
      text-align: center;
      color: #ffffff;
    }
  }
  .img {
    vertical-align: middle;
  }
  .pdf {
    position: relative;
    margin-top: 16px;

    .right {
      width: 14px;
      height: 14px;
      position: absolute;
      top: 18px;
      right: 6px;
    }
  }
  .uploader {
    margin-top: 10px;
  }
  .textarea {
    margin-top: 10px;
    border: 1px solid #eee;
    height: 204px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/business/product/add.vue